import { createPrefixedConstants } from 'app/common/CommonUtils';

export default createPrefixedConstants(
  'dashboard',
  `
    RUN_ZAP
    RUN_ZAP_DONE

    RUN_ZAP_STATUS
    RUN_ZAP_STATUS_DONE

    LOAD_HELD_REASONS
    LOAD_HELD_REASONS_DONE

    HANDLE_HELD_TASKS_BANNER_TOGGLE
    CREATE_HELD_TASK_SNAPSHOT
  `
);
